<template>
  <ts-dialog :visible.sync="visible">
    <div class="flex flex-col items-center justify-center">
      <p class="mb-4 text-3xl" v-html="message"></p>
    </div>
  </ts-dialog>
</template>

<script>
export default {
  name: 'DownloadpendingAlert',
  data() {
    return {
      visible: false,
      message: 'The selected assets are still being processed ! Please retry downloading soon'
    };
  },
  created() {
    window.EventBus.$on('download.pending', message => {
      this.visible = true;
      this.message = message || this.message;
    });
  }
};
</script>

<style scoped>
.text-3xl {
  font-size: 1.2rem;
  text-align: center;
  word-break: break-word;
}
</style>